import axios from '../../http';

function initialState () {
  return {
    requesting: {},
    vehicle: {},
    vehicleMakes: [],
    vehicleModels: [],
    vehicleEngines: [],
    compareVehicles: [],
    vehicleChargeTypes: [],
    suppliers: [],
    suppliersGas: [],
    suppliersElectricity: [],
    addresses: [],
    usageTypes: [
      { label: 'I spend', value: 0 },
      { label: 'I use', value: 1 }
    ],
    usageUnits: [
      { label: 'yearly', value: 1 },
      { label: 'monthly', value: 2 },
      { label: 'quarterly', value: 3 }
    ],
    tariffs: [],
    tariffsGas: [],
    tariffsElectricity: [],
    paymentMethods: [
      { name: 'monthlyDirectDebit', label: 'Monthly Direct Debit' },
      { name: 'quarterlyDirectDebit', label: 'Quarterly Direct Debit' },
      { name: 'cashOrCheque', label: 'Cash & Cheque' },
      { name: 'prePaymentMeter', label: 'Prepayment Meter' }
    ],
    fuelTypes: [
      { name: 'gas', label: 'Gas' },
      { name: 'electricity', label: 'Electricity' },
      { name: 'gasElectricity', label: 'Gas & Electricity' }
    ],
    rateTypes: [
      { name: 'any', label: 'Any' },
      { name: 'fixed', label: 'Fixed' },
      { name: 'variable', label: 'Variable' }
    ],
    greens: [
      { value: 'any', label: 'Any' },
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ],
    prepayments: [
      { label: 'Pre-Pay Key Meter', id: 1 },
      { label: 'Pre-Pay Token Meter', id: 2 },
      { label: 'Pre-Pay Smartcard Meter', id: 3 }
    ],
    houseTypes: [],
    bedRooms: [],
    occupancyFrequencies: [],
    energyEfficiencies: [],
    fuelUseTypes: [],
    employmentStatuses: [],
    titles: [],
    specialNeeds: [],
    residentialStatuses: [],
    directDebitDays: []
  };
}

const state = initialState();

const getters = {};

const actions = {
   async findVehicle({ commit, dispatch }, { registrationNumber }) {
      try {
           commit('updateRequesting', { prop: 'vehicle', value: true });

           const res = await axios({
               method: 'POST',
               url: '/request/ev/regno',
               data: { registrationNumber }
           });

           commit('updateState', { prop: 'vehicle', value: res.data || {} });
           commit('updateRequesting', { prop: 'vehicle', value: false });
      } catch ({ data }) {
           commit('updateState', { prop: 'vehicle', value: [] });
           commit('updateRequesting', { prop: 'vehicle', value: false });
      }
   },
   async getVehicleMakes({ commit, dispatch }, { electricVehicle }) {
      try {
           commit('updateRequesting', { prop: 'vehicleMakes', value: true });
           const res = await axios({
               method: 'GET',
               url: '/request/ev/make'
           });

           commit('updateState', {
               prop: 'vehicleMakes',
               value: electricVehicle ? res.data.filter(({ fuels })  => {
                 return fuels.find(({ fuelName }) => fuelName == 'Electric');
               }) : res.data
           });

           commit('updateRequesting', { prop: 'vehicleMakes', value: false });

      } catch ({ data }) {
           commit('updateState', { prop: 'vehicleMakes', value: [] });
           commit('updateRequesting', { prop: 'vehicleMakes', value: false });
      }
   },
   async getVehicleModels({ commit, dispatch }, { id, electricVehicle }) {
      try {
           commit('updateRequesting', { prop: 'vehicleModels', value: true });
           const res = await axios({
               method: 'GET',
               url: `/request/ev/make/${id}/model`
           });

           commit('updateState', {
               prop: 'vehicleModels',
               value: electricVehicle ? res.data.filter(({ fuel }) => fuel == 'Electric') : res.data
           });
           commit('updateRequesting', { prop: 'vehicleModels', value: false });
      } catch ({ data }) {
           commit('updateState', { prop: 'vehicleModels', value: [] });
           commit('updateRequesting', { prop: 'vehicleModels', value: false });
      }
   },
   async getVehicleEngines({ commit, dispatch }, { id, electricVehicle }) {
      try {
           commit('updateRequesting', { prop: 'vehicleEngines', value: true });
           const res = await axios({
               method: 'GET',
               url: `/request/ev/model/${id}/enginesize`
           });
           commit('updateState', { prop: 'vehicleEngines', value: electricVehicle ? res.data.filter(({ fuel }) => fuel == 'Electric') : res.data });
           commit('updateRequesting', { prop: 'vehicleEngines', value: false });
      } catch ({ data }) {
           commit('updateState', { prop: 'vehicleEngines', value: [] });
           commit('updateRequesting', { prop: 'vehicleEngines', value: false });
      }
   },
   async getVehicleChargeTypes({ commit, dispatch }) {
      try {
           commit('updateRequesting', { prop: 'vehicleChargeTypes', value: true });

           commit('updateState', {
               prop: 'vehicleChargeTypes',
               value: [
                   { label: '3-pin plug', id: 1 },
                   { label: '11kW connection', id: 2 },
                   { label: '22kW', id: 3 }
               ]
           });

           commit('updateRequesting', { prop: 'vehicleChargeTypes', value: false });
      } catch ({ data }) {
           commit('updateState', { prop: 'vehicleChargeTypes', value: [] });
           commit('updateRequesting', { prop: 'vehicleChargeTypes', value: false });
      }
   },
  async getSuppliers ({ rootState, rootGetters, commit, dispatch }, fuelType) {
    const { quote } = rootState;
    const switchType = rootGetters['quote/quoteType'];
    let prop = fuelType === 'gas' ? 'suppliersGas' : 'suppliersElectricity';
    const paymentKey = fuelType === 'gas' ? 'gasCurrentPayMethod' : 'electricityCurrentPayMethod';
    const data = {
      postcode: quote.postcode,
      switchType: fuelType === 'gas' ? 'gasToGas' : 'electricityToElectricity',
      currentPayMethod: quote[paymentKey],
      economy7Percentage: quote.isEconomy7 ? 1 : 0
    };

    if (switchType === 'dualConsolidatedToDualConsolidated') {
      prop = 'suppliers';
      data.switchType = switchType;
      data.currentPayMethod = quote.currentPayMethod;
    }

    const valid = fuelType &&
            data.postcode &&
            data.switchType &&
            data.currentPayMethod;

    if (!valid) return;

    try {
      commit('updateRequesting', { prop, value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/suppliers',
        data
      });

      const suppliersDto = res.data.suppliersDto;
      commit('updateState', {
        prop,
        value: suppliersDto.electricitySuppliers || suppliersDto.gasSuppliers || suppliersDto.dualConsolidatedSuppliers
      });
      commit('updateRequesting', { prop, value: false });
    } catch (error) {
      commit('updateState', { prop, value: [] });
      commit('updateRequesting', { prop, value: false });
    }
  },
  async getAddresses({ rootState, commit, dispatch }, postcode) {
    const { gbData } = rootState.app_settings;
    let addressList = [];
    commit('updateRequesting', { prop: 'addresses', value: true });

    try {
      if (gbData) {
        const res = await axios({
          method: 'GET',
          url: '/request/address/list/postcode',
          params: { postcode }
        });

        commit('updateState', { prop: 'addresses', value: res.data.verifiedAddresses });
        addressList = res.data.verifiedAddresses;
      } else {
        const res = await axios({
          method: 'GET',
          url: '/request/address/recco',
          params: { postcode }
        });
        commit('updateState', { prop: 'addresses', value: res.data });

        addressList = res.data;
      }

      commit('updateRequesting', { prop: 'addresses', value: false });
    } catch ({ data }) {
      commit('updateState', { prop: 'addresses', value: [] });
      commit('updateRequesting', { prop: 'addresses', value: false });
    } finally {
      return addressList;
    }
  },
  async getXoserveMeters({ commit, dispatch }, data) {
    const empty = [{ elecdetails: [], gasdetails: [], mpan: null, mprn: null }];
    const { xoserveAddressCode, mpancore, ...rest } = data;

    try {
      commit('updateRequesting', { prop: 'xoserveMeters', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/address/recco/details',
        data: {
          ...rest,
          mpanCores: data.mpancore,
          xoserveAddressCodes: data.xoserveAddressCode
        }
      });

      if (res.status == 200 && res.data.length) {
        const model = res.data[0];

        return {
          ...model,
          elecdetails: model.elecdetails || [],
          gasdetails: model.gasdetails || []
        };
      }

      return empty;
    } catch ({ data }) {
      return empty;
    } finally {
      commit('updateRequesting', { prop: 'xoserveMeters', value: false });
    }
  },
  async getTariffs ({ rootState, rootGetters, commit, dispatch }, { fuelType, supplierId }) {
    const { quote } = rootState;
    const quoteType = rootGetters['quote/quoteType'];
    let prop = fuelType === 'gas' ? 'tariffsGas' : 'tariffsElectricity';
    const paymentKey = fuelType === 'gas' ? 'gasCurrentPayMethod' : 'electricityCurrentPayMethod';
    const data = {
      switchType: fuelType === 'gas' ? 'gasToGas' : 'electricityToElectricity',
      supplierId,
      postcode: quote.postcode,
      currentPayMethod: quote[paymentKey],
      economy7Percentage: quote.isEconomy7 ? 1 : 0
    };

    if (quoteType === 'dualConsolidatedToDualConsolidated') {
      prop = 'tariffs';
      data.switchType = quoteType,
      data.currentPayMethod = quote.currentPayMethod;
    }

    const valid = fuelType &&
            supplierId &&
            data.postcode &&
            data.switchType &&
            data.currentPayMethod;

    if (!valid) return;
    
    try {
      commit('updateRequesting', { prop, value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/tariffs',
        data
      });

      commit('updateState', {
        prop,
        value: res.data.tariffsDto.tariffs
      });
      commit('updateRequesting', { prop, value: false });
    } catch ({ data }) {
      commit('updateState', { prop, value: [] });
      commit('updateRequesting', { prop, value: false });
    }
  },
  async getEstimateList ({ commit, dispatch }) {
    try {
      commit('updateRequesting', { prop: 'estimate', value: true });
      const res = await axios({
        method: 'GET',
        url: '/request/estimation/detail/all'
      });

      const { data } = res;

      commit('updateState', { prop: 'bedRooms', value: data.response.bedRooms });
      commit('updateState', { prop: 'fuelUseTypes', value: data.response.fuelUseTypes });
      commit('updateState', { prop: 'houseTypes', value: data.response.houseTypes });
      commit('updateState', { prop: 'occupancyFrequencies', value: data.response.occupancyFrequencies });
      commit('updateState', { prop: 'energyEfficiencies', value: data.response.energyEfficiencies });
      commit('updateRequesting', { prop: 'estimate', value: false });
    } catch (error) {
      commit('updateState', { prop: 'bedRooms', value: [] });
      commit('updateState', { prop: 'fuelUseTypes', value: [] });
      commit('updateState', { prop: 'houseTypes', value: [] });
      commit('updateState', { prop: 'occupancyFrequencies', value: [] });
      commit('updateState', { prop: 'energyEfficiencies', value: [] });
      commit('updateRequesting', { prop: 'estimate', value: false });
    }
  },
  async getEmploymentStatusList ({ commit, dispatch, rootState }) {
    const { switchKey } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'employmentStatuses', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/employment-statuses',
        data: { switchKey }
      });

      const { data } = res;
      const statuses = data.employmentStatusesDto.employmentStatuses;
      const employmentStatuses = Object.entries(statuses).map(item => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'employmentStatuses', value: employmentStatuses });
      commit('updateRequesting', { prop: 'employmentStatuses', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'employmentStatuses', value: false });
    }
  },
  async getTitleList ({ commit, rootState }) {
    const { switchKey } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'titles', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/titles',
        data: { switchKey }
      });

      const { data } = res;
      const titles = Object.entries(data.titlesDto.titles).map(item => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'titles', value: titles });
      commit('updateRequesting', { prop: 'titles', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'titles', value: false });
    }
  },
  async getSpecialNeedsList ({ state, commit, rootState }) {
    const { switchKey } = rootState.storage;
    if (state.specialNeeds.length) return;

    try {
      commit('updateRequesting', { prop: 'specialNeeds', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/special-needs',
        data: { switchKey }
      });

      const { data } = res;
      const specialNeeds = Object.entries(data.specialNeedsDto.specialNeeds).map(item => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'specialNeeds', value: specialNeeds });
      commit('updateRequesting', { prop: 'specialNeeds', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'specialNeeds', value: false });
    }
  },
  async getResidentialStatusList ({ commit, rootState }) {
    const { switchKey } = rootState.storage;

    try {
      commit('updateRequesting', { prop: 'residentialStatuses', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/residential-statuses',
        data: { switchKey }
      });

      const { data } = res;
      const residentialStatuses = Object.entries(data.residentialStatusesDto.residentialStatuses).map(item => ({
        id: item[0],
        label: item[1]
      }));

      commit('updateState', { prop: 'residentialStatuses', value: residentialStatuses });
      commit('updateRequesting', { prop: 'residentialStatuses', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'residentialStatuses', value: false });
    }
  },
  async getDirectDebitDaysList ({ state, commit, rootState }) {
    const { switchKey } = rootState.storage;

    if (state.directDebitDays.length) return;

    try {
      commit('updateRequesting', { prop: 'directDebitDays', value: true });
      const res = await axios({
        method: 'POST',
        url: '/request/switch/pro/detail/direct-debit-days',
        data: { switchKey }
      });

      const { data } = res;
      const directDebitDays = Object.entries(data.directDebitDayOfTheMonthsDto.directDebitDayOfTheMonths).map(item => ({
        id: item[0],
        label: `${item[1]} day of the month`
      }));

      commit('updateState', { prop: 'directDebitDays', value: directDebitDays });
      commit('updateRequesting', { prop: 'directDebitDays', value: false });
    } catch (error) {
      commit('updateRequesting', { prop: 'directDebitDays', value: false });
    }
  },
  resetList ({ commit }, prop) {
    commit('updateState', { prop, value: [] });
    commit('updateRequesting', { prop, value: false });
  }
};

const mutations = {
  updateRequesting (state, { prop, value }) {
    state.requesting = {
      ...state.requesting,
      [prop]: value
    };
  },
  updateState (state, { prop, value }) {
    state[prop] = value;
  },
  resetState (state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
